/**
 * Cosmic Magnetic Button Engine
 * Provides a high-performance "Magnetic" pull effect for CTAs.
 * Features: requestAnimationFrame, center-offset calculations, and smooth damping.
 */

class CosmicMagnetic {
  constructor() {
    this.targets = document.querySelectorAll('[data-magnetic]');
    this.mouse = { x: 0, y: 0 };
    this.init();
  }

  init() {
    if (this.targets.length === 0) return;

    window.addEventListener('mousemove', (e) => {
      this.mouse.x = e.clientX;
      this.mouse.y = e.clientY;
    });

    this.targets.forEach(target => {
      const strength = parseFloat(target.getAttribute('data-magnetic-strength')) || 0.3;
      const inner = target.querySelector('.cosmic-btn-text') || target; // Animate target itself
      
      let state = {
        x: 0,
        y: 0,
        cx: 0,
        cy: 0
      };

      const animate = () => {
        const rect = target.getBoundingClientRect();
        
        // Calculate distance from center
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        
        // Check if mouse is within a "magnetic area" (button radius + margin)
        const area = 150; // trigger pull within 150px
        const distX = this.mouse.x - centerX;
        const distY = this.mouse.y - centerY;
        const distance = Math.sqrt(distX * distX + distY * distY);

        if (distance < area) {
          // Inside magnetic field
          state.x = distX * strength;
          state.y = distY * strength;
        } else {
          // Reset
          state.x = 0;
          state.y = 0;
        }

        // Apply smooth lerp/easing
        state.cx += (state.x - state.cx) * 0.15;
        state.cy += (state.y - state.cy) * 0.15;

        // Apply the transform
        target.style.transform = `translate3d(${state.cx}px, ${state.cy}px, 0)`;
        
        requestAnimationFrame(animate);
      };

      animate();
    });
  }
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  new CosmicMagnetic();
});
